import { faPencil, faTrash } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FilterMatchMode } from "primereact/api";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { FileUpload } from "primereact/fileupload";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { PlayerPosition } from "src/app/enums/PlayerPosition";
import { PlayerStatus } from "src/app/enums/PlayerStatus";
import { GetPropertiesFromEnum, ResizeImage, safeJson } from "src/app/helpers/Index";
import { Player, Sponsor } from "src/app/interfaces/Index";
import { FileService, PlayerService, SponsorService } from "src/app/services/Index";
import { colours } from "src/app/Styles";
import { environment } from "src/environments/environment";
import "./AdminHomeTeam.css";

type Props = {};
type State = {
	isLoading: boolean;
	filters1: any;
	globalFilter: string;
	masterItems: Player[];
	items: Player[];
	selectedItem: Player;
	selectedItems: Player[];
	showDeleteModal: boolean;
	showDeleteSelectionModal: boolean;
	showItemInfoModal: boolean;
	sponsors: Sponsor[];
	submitted: boolean;
};

export class AdminHomeTeam extends React.Component<Props, State> {
	dt: any;	
	toast: any;
	itemName: string = "Scunthorpe United Player";
	itemNamePlural: string = "Scunthorpe United Players";

	constructor(props: Props) {
		super(props);
		this.state = {isLoading: false, filters1: {"global": { value: null, matchMode: FilterMatchMode.CONTAINS }}, globalFilter: "", masterItems: [], selectedItem: new Player(), selectedItems: [], items: [], showDeleteModal: false, showDeleteSelectionModal: false, showItemInfoModal: false, sponsors: [], submitted: false};
	}

	categoryChange(e: any) {
		let selectedItem = {...this.state.selectedItem};
		// selectedItem.type = e.value;
		this.setState({selectedItem});
	}

	componentDidMount() {
		this.getSponsors();
		this.getItems();
	}

	deleteItemFooter() {
		return (
			<>
				<Button className="p-button-text" icon="pi pi-times" label="No" onClick={() => this.setState({showDeleteModal: false})}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Yes" onClick={(data) => this.deleteItemConfirm(data)}></Button>
			</>
		);
	}

	deleteItemsFooter() {
		return (
			<>
				<Button className="p-button-text" icon="pi pi-times" label="No" onClick={() => this.setState({showDeleteSelectionModal: false})}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Yes" onClick={() => this.deleteSelectedItemConfirm()}></Button>
			</>
		);
	}

	async deleteItemConfirm(rowData: any) {
		const res = await (await PlayerService.deleteSingleById(this.state.selectedItem.id));
		console.log(res)
		if (!res.ok) {
			this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
		}
		this.toast.show({closable: false, detail: this.state.selectedItem.playerName + " has been deleted", life: 5000, severity: "warn", summary: "Player deleted!"});
		this.getItems();
		this.setState({showDeleteModal: false});
	}

	deleteSelectedItemConfirm() {}

	itemInfoFooter() {
			return (
			<>
				<Button className="p-button-text" icon="pi pi-times" label="Cancel" onClick={() => this.setState({selectedItem: new Player(), showItemInfoModal: false})}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Save" onClick={() => this.saveItem()}></Button>
			</>
			);
	}

	globalFilterChange(e: any) {
		let value = ""
		if (e !== ""){
			value = e.target.value;
			let newData = this.state.masterItems.filter(function(item){
				return item.playerName?.toLowerCase().includes(value.toLowerCase());
			 });
			 this.setState({items:newData});
		} else this.setState({items:this.state.masterItems});
		this.setState({globalFilter:value});    
	}

	async getItems() {
		this.setState({isLoading: true});
		const res = await safeJson(PlayerService.getHomeTeam());
		if (res && res.error) {
			this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
			this.setState({isLoading: false});
		}
		this.setState({isLoading: false, items: res, masterItems:res});
	}

	async getSponsors() {
		this.setState({isLoading: true});
		const res = await safeJson(SponsorService.getAll());
		if (res && res.error) {
			this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
			this.setState({isLoading: false});
		}
		this.setState({isLoading: false, sponsors: res});
	}

	inputChange(e: any, name: string) {
		const val = (e.target && e.target.value) || "";
		let selectedItem = new Player({...this.state.selectedItem});
		// @ts-ignore // Required to be able to use a generic function to change the values
		selectedItem[name] = val;
		this.setState({selectedItem});
	}

	inputNumberChange(e: any, name: string) {
		const val = e.value || 0;
		let selectedItem = new Player({...this.state.selectedItem});
		// @ts-ignore // Required to be able to use a generic function to change the values
		selectedItem[name] = val;
		this.setState({selectedItem});
	}

	render() {
		return (
			<>
				<Row>
					<Col>
						<div className="card" style={{paddingTop: "1.5rem"}}>
							<h5 style={{paddingBottom: "1rem", paddingLeft: "1.5rem"}}>{this.itemNamePlural}</h5>
							<Toolbar left={() => this.renderLeftToolbarButtons()} right={() => this.renderRightToolbarButtons()}></Toolbar>
							<DataTable loading={this.state.isLoading} onSelectionChange={(e) => this.setState({selectedItems: e.value})} ref={(el) => this.dt = el} scrollable scrollHeight="flex" selection={this.state.selectedItems} style={{height: "calc(100vh - 17.5rem)"}} value={this.state.items} sortField="playerNumber" sortOrder={1}>
								{/* <Column headerStyle={{width: 50}} selectionMode="multiple"></Column> */}
								<Column header="Avatar" body={(rowData: any) => <img alt={rowData.image} className="product-image" src={`${rowData.mugshotUrl}`} height="50"/>}></Column>
								<Column field="playerNumber" header="Player Number" sortable ></Column>
								<Column field="playerName" header="Player Name" sortable ></Column>
								<Column field="playerStatus" header="Active?" sortable body={(rowData: any) => this.renderPlayerStatus(rowData)}></Column>
								<Column style={{width: 75}} body={(rowData) => (
									<div className="actions">
										<Button onClick={() => this.setState({selectedItem: rowData, showItemInfoModal: true})} style={{backgroundColor: colours.graphs.positive, borderColor: colours.graphs.positive, height: 30, justifyContent: "center", margin: 2, padding: 0, width: 30}}>
											<FontAwesomeIcon icon={faPencil} style={{color: colours.white}}/>
										</Button>
										<Button onClick={() => this.setState({selectedItem: rowData, showDeleteModal: true})} style={{backgroundColor: colours.graphs.positive, borderColor: colours.graphs.positive, height: 30, justifyContent: "center", margin: 2, padding: 0, width: 30}}>
											<FontAwesomeIcon icon={faTrash} style={{color: colours.white}}/>
										</Button>
									</div>
								)}></Column>
							</DataTable>
							<Dialog className="p-fluid" footer={() => this.itemInfoFooter()} header={this.itemName + " Details"} modal onHide={() => this.setState({ showItemInfoModal: false })} style={{ width: "75%" }} visible={this.state.showItemInfoModal}>
										<Row>
										<Col>
												<div className="field" style={{ marginBottom: 10 }}>
													<label htmlFor="playerName">Player Name <span style={{color:"red"}}>*</span></label>
													<InputText id="playerName" value={this.state.selectedItem.playerName} onChange={(e) => this.inputChange(e, "playerName")}/>
												</div>
											</Col>
											<Col>
												<div className="field" style={{ marginBottom: 10 }}>
													<label htmlFor="playerNumber">Player Number <span style={{color:"red"}}>*</span></label>
													<InputText id="playerNumber" value={this.state.selectedItem.playerNumber} onChange={(e) => this.inputChange(e, "playerNumber")}/>
												</div>
											</Col>
										</Row>
										<Row>
										<Col>
										<div className="field" style={{marginBottom: 10}}>
											<label htmlFor="playerPosition">Player Position <span style={{color:"red"}}>*</span></label>
											<Dropdown id="playerPosition" onChange={(e:any) => this.setState({selectedItem: {...this.state.selectedItem, playerPosition: e.value}})} options={GetPropertiesFromEnum(PlayerPosition)} optionLabel="name" optionValue="id" style={{width: "100%"}} value={this.state.selectedItem.playerPosition}/>
										</div>
									</Col>
									<Col>
										<div className="field" style={{marginBottom: 10}}>
											<label htmlFor="playerStatus">Player Status <span style={{color:"red"}}>*</span></label>
											<Dropdown id="playerStatus" onChange={(e:any) => this.setState({selectedItem: {...this.state.selectedItem, playerStatus: e.value}})} options={GetPropertiesFromEnum(PlayerStatus)} optionLabel="name" optionValue="id" style={{width: "100%"}} value={this.state.selectedItem.playerStatus}/>
										</div>
									</Col>
										</Row>
										<Row>
										<Col>
										<div className="field" style={{marginBottom: 10}}>
											<label htmlFor="sponsorId">Player Sponsor</label>
											<Dropdown id="sponsorId" onChange={(e:any) => this.setState({selectedItem: {...this.state.selectedItem, sponsorId: e.value}})} options={this.state.sponsors} optionLabel="name" optionValue="id" style={{width: "100%"}} value={this.state.selectedItem.sponsorId}/>
										</div>
									</Col>
										</Row>
										<Row>
										<Col>
											<Col>
												<div className="field" style={{ marginBottom: 10 }}>
													<label htmlFor="mugshotUrl" style={{ width: "100%" }}>Player Image</label>
													<img id="mugshotUrl" src={this.state.selectedItem.mugshotUrl} style={{ height: 90, marginBottom: 10, marginTop: 10 }}></img>
												</div>
											</Col>
											<Col xs={5}>
										<FileUpload accept="image/*" auto customUpload name="mugshotUrl" style={{marginBottom: 10}} uploadHandler={(data) => this.uploadImage(data, "mugshotUrl")} mode="basic"></FileUpload>
									</Col>
									</Col>
											<Col>
											<Col>
												<div className="field" style={{ marginBottom: 10 }}>
													<label htmlFor="celebrationImage" style={{ width: "100%" }}>Celebration Image</label>
													<img id="celebrationImage" src={this.state.selectedItem.celebrationImage} style={{ height: 90, marginBottom: 10, marginTop: 10 }}></img>
												</div>
											</Col>
											<Col xs={5}>
										<FileUpload accept="image/*" auto customUpload name="celebrationImage" style={{marginBottom: 10}} uploadHandler={(data) => this.uploadImage(data, "celebrationImage")} mode="basic"></FileUpload>
									</Col>
									</Col>
									<Col>
									<Col>
												<div className="field" style={{ marginBottom: 10 }}>
													<label htmlFor="manOfTheMatchImage" style={{ width: "100%" }}>Man of the Match Image</label>
													<img id="manOfTheMatchImage" src={this.state.selectedItem.manOfTheMatchImage} style={{ height: 90, marginBottom: 10, marginTop: 10 }}></img>
												</div>
											</Col>
											<Col xs={5}>
										<FileUpload accept="image/*" auto customUpload name="manOfTheMatchImage" style={{marginBottom: 10}} uploadHandler={(data) => this.uploadImage(data, "manOfTheMatchImage")} mode="basic"></FileUpload>
									</Col>
									</Col>
										</Row>
							</Dialog>
						</div>
					</Col>
				</Row>
				<Dialog footer={() => this.deleteItemFooter()} header="Confirm" modal onHide={() => this.setState({showDeleteModal: false})} style={{width: 550}} visible={this.state.showDeleteModal}>
								<div className="d-flex align-items-center justify-content-center">
									<i className="pi pi-exclamation-triangle mr-3" style={{fontSize: "2rem", marginRight: "0.5rem"}}/>
									{this.state.selectedItem &&
										<span>Are you sure you want to delete <b>{this.state.selectedItem.playerName}</b>?</span>
									}
								</div>
							</Dialog>
				<Toast ref={(el) => this.toast = el}></Toast>
			</>
		);
	}

	renderLeftToolbarButtons() {
		return (
			<>
				<Button icon="pi pi-plus" label="New" style={{backgroundColor: colours.graphs.positive, borderColor: colours.graphs.positive, marginRight: 10}} onClick={() => this.setState({selectedItem: new Player(), showItemInfoModal: true})}></Button>
				{/* <Button disabled={!this.state.selectedItems || !this.state.selectedItems.length} icon="pi pi-trash" label="Delete" style={{backgroundColor: colours.graphs.negative, borderColor: colours.graphs.negative, marginRight: 10}} onClick={() => this.setState({showDeleteSelectionModal: true})}></Button> */}
			</>
		);
	}

	renderRightToolbarButtons() {
		return (
			<>
			<div className="flex justify-content-between">
                <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined" onClick={()=>{this.globalFilterChange("")}} />
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={this.state.globalFilter} onChange={(e)=> {this.globalFilterChange(e)}} placeholder="Keyword Search" />
                </span>
            </div>
				<Button icon="pi pi-upload" label="Export" style={{backgroundColor: colours.buttons.export, borderColor: colours.buttons.export, marginLeft: 10}} onClick={() => this.dt.exportCSV()}></Button>
			</>
		);
	}

	renderPlayerStatus(e: any) {
		switch (e.playerStatus) {
			case 0:
				return (<><span className={`row-badge status-success`}>Starting XI</span></>)
			case 10:
				return (<><span className={`row-badge status-warning`}>Substitute</span></>)
			case 20:
				return (<><span className={`row-badge status-error`}>Inactive</span></>)
			default:
				return (<><span className={`row-badge status-error`}>Inactive</span></>)
		}
	}

	async saveItem() {
		this.setState({isLoading: true});

		let selectedItem = {...this.state.selectedItem};
		// @ts-ignore // Required to be able to change the values
		selectedItem.teamId = 1;
		await this.setState({selectedItem});

		if (this.state.selectedItem.id === -1 || this.state.selectedItem.id === undefined) { // Create new
			const res = await safeJson(PlayerService.createSingle(this.state.selectedItem));
			if (res && res.error) {
				this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
				this.setState({isLoading: false});
			}
			this.setState({isLoading: false, showItemInfoModal:false});
			this.toast.show({closable: false, detail: this.itemName + " has been created", life: 5000, severity: "success", summary: this.itemName + " created!"});
		} else { // Save existing
			const res = await safeJson(PlayerService.updateSingleById(this.state.selectedItem.id,this.state.selectedItem));
			if (res && res.error) {
				this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
				this.setState({isLoading: false});
			}
			this.setState({isLoading: false, showItemInfoModal:false});
			this.toast.show({closable: false, detail: this.itemName + " has been saved", life: 5000, severity: "success", summary: this.itemName + " saved!"});
		}
		this.getItems();
	}

	
	async uploadImage(data: any, property: string) {
		const containerName = "uploads";
		const uploadData = new FormData();
		uploadData.append("containerName", containerName);
		uploadData.append("files", await ResizeImage(data.files[0]));
		uploadData.append("mimeTypeKey", "Images");
		const response = await(await FileService.upload(uploadData)).json();
		let selectedItem = {...this.state.selectedItem};
		// @ts-ignore // Required to be able to change the values
		selectedItem[property] = `${environment.server.storageUrl}/${response[0].location}`;
		await this.setState({selectedItem});
	}
		
}